"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function removeUndefined(obj) {
    return (0, lodash_1.pickBy)(obj, function (x) { return x !== undefined; });
}
exports.default = removeUndefined;
